import { User } from "@/api";

export const schedulePermissions = {
  addSchedule: [User.ERole.admin],
  editSchedule: [User.ERole.admin],
};
